import { render } from "./PageHeaderDefault.vue?vue&type=template&id=1ace12f6"
import script from "./PageHeaderDefault.vue?vue&type=script&lang=js"
export * from "./PageHeaderDefault.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__